import React from 'react';
import { Grid, Button, CircularProgress } from '@material-ui/core';
import { useFormikContext, FormikValues } from 'formik';

import { IFormNavigationButtonsProps } from './interfaces';
import { useStyles } from './styles';

const FormNavigationButtons: React.FC<IFormNavigationButtonsProps> = ({
  isViewOnly = false,
  backButtonOnClick,
  backButtonLabel = 'Voltar',
  submitButtonOnClick,
  submitButtonLabel = 'Cadastrar',
  secondarySubmitButtonOnClick,
  secondarySubmitButtonLabel,
  isSubmitting,
}: IFormNavigationButtonsProps) => {
  const classes = useStyles();
  const { submitForm } = useFormikContext<FormikValues>();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      className={classes.buttons}
    >
      <Grid item xs={4}>
        <Button
          data-cy="form-navigation-buttons__button--back"
          size="large"
          variant="outlined"
          type="button"
          onClick={backButtonOnClick}
        >
          {backButtonLabel}
        </Button>
      </Grid>
      {!isViewOnly && (
        <Grid
          item
          xs={8}
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          {secondarySubmitButtonLabel && (
            <Grid item className={classes.secondaryActionButton}>
              <Button
                data-cy="form-navigation-buttons__button--secondary-submit"
                size="large"
                color="primary"
                variant="outlined"
                onClick={secondarySubmitButtonOnClick}
              >
                {secondarySubmitButtonLabel}
              </Button>
            </Grid>
          )}
          <Grid item>
            <Button
              data-cy="form-navigation-buttons__button--primary-submit"
              size="large"
              color="primary"
              variant="contained"
              onClick={submitButtonOnClick || submitForm}
            >
              {isSubmitting ? (
                <CircularProgress color="secondary" size={20} />
              ) : (
                submitButtonLabel
              )}
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default FormNavigationButtons;
